/*!
 * @copyright
 * Copyright(c) 2022 SICK AG
 */

/**
 * @var actionKeys Keyboard keys that often trigger interaction.
 * Usually used to intercept keyup events
 */
export const actionKeys = [' ', 'Space', 'Enter'];
/**
 * Prevents the automatic scroll behaviour that is taking place when pressing the space key
 * @param event KeyboardEvent The event received
 * @example
 * ```
 * const elm = document.createElement('div')
 * elm.addEventListener('keydown', preventSpaceScroll);
 * ```
 */

export const preventSpaceScroll = event => {
  const {
    key
  } = event;

  if (key === ' ' || key === 'Space') {
    event.preventDefault();
  }
};
/**
 * Create a key trap function thats callback is invoked when the received keyboard interaction is in the list of valid action keys
 * @param callback Function The function to execute
 * @returns An event listener function that can will be called when the key codes are action keys
 * @example
 * ```
 * const elm = document.createElement('div');
 * const doSomethingOnKeyDown = createClickTrap(() => console.log('action is valid'));
 * elm.addEventListener('keydown', doSomethingOnKeyDown);
 * ```
 */

export const createKeyTrap = callback => event => {
  const {
    key
  } = event;

  if (actionKeys.includes(key)) {
    callback(event);
  }
};
